import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Team from "@/pages/Team";

export const Route = createFileRoute("/en/about-qbd/team")({
  head: () => buildRouteHead("/en/about-qbd/team"),
  component: Team,
});

